import store from '@/state/store'
let fields = [
  {
    key: 'createdOn',
    label: 'global.field.date',
    header: 'date',
    filter: false,
    width: 20,
    disabled: true,
  },
  {
    key: 'time',
    label: 'global.field.time',
    header: 'time',
    filter: false,
    width: 20,
    disabled: true,
  },
  {
    key: 'vehicle',
    label: 'report.fields.licensePlate',
    header: 'license_plate',
    filter: true,
    width: 20,
  },
  {
    key: 'vehicleType',
    label: 'report.fields.vehicleType',
    header: 'vehicle_type',
    filter: false,
    width: 30,
  },
  {
    key: 'driver',
    label: 'report.fields.driver',
    header: 'driver',
    filter: true,
    width: 20,
  },
  {
    key: 'alert',
    label: 'report.fields.alertType',
    header: 'alert',
    filter: true,
    width: 10,
  },
  {
    key: 'isImportant',
    label: 'report.fields.urgentLevel',
    header: 'is_important',
    filter: true,
    width: 10,
  },
  {
    key: 'formattedAlertData',
    label: 'report.fields.detail',
    header: 'alert_data',
    filter: false,
    width: 10,
  },
  {
    key: 'address',
    label: 'report.fields.location',
    header: 'address',
    filter: false,
    width: 10,
    tdClass: 'address-td',
  },
  {
    key: 'vehicleGroup',
    label: 'report.fields.vehicleGroup',
    header: 'vehicle_group',
    filter: false,
    width: 10,
  },
]
if (store.getters['identity/hasAccess'](['alert_geofence_column:read'])) {
  fields.splice(9, 0, {
    key: 'geofence',
    label: 'report.fields.geolocation',
    header: 'geofence',
    filter: false,
    width: 30,
  })
}
if (store.getters['identity/hasAccess'](['false_alert_report:read'])) {
  fields.push(
    {
      key: 'falseAlert',
      label: 'report.fields.checkingStatus',
      header: 'false_alert',
      filter: false,
      width: 30,
    },
    {
      key: 'falseAlertReason',
      label: 'report.fields.falseAlertReason',
      header: 'false_alert_reason',
      filter: false,
      width: 30,
      tdAttr: {
        style: 'border-right:0;',
      },
      thAttr: {
        style: 'border-right:0;',
      },
    }
  )
}
if (
  store.getters['identity/hasAccess']([
    'e1c-web-dms:read',
    'e1g-web-adas:read',
    'seat_belt_alert:read',
    'fatigue_driving_alert:read',
  ])
) {
  fields.push({
    key: 'downloadVideo',
    label: 'report.fields.downloadVideo',
    header: 'download_video',
    filter: false,
    width: 10,
    tdAttr: {
      style: 'right:0px; position:sticky; border-left:1px solid #e6e7ec; text-align:center;',
    },
    thAttr: {
      style:
        'right:0px; position:sticky; z-index:1;border-left:1px solid #e6e7ec; text-align:center;',
    },
  })
}
export default fields
